import { AxisSwitcher, Button, H1, Image, P, Section, SpacerWrapper, Wrapper } from '@ahmdigital/ui';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useRouter } from 'next/router';

import { buildNavigationUrl } from '../../utils/navigation';
import { STEP_SLUG } from '../../constants';
import AccordionSection from '../../../../components/sections/accordion-section';
import data from './data';
import questionsHeroImage from '../../../../images/questions-hero.svg';
import StepList from '../../../../components/step-list';
import styles from './styles.module.sass';
import usePrefetch from '../../../../utils/use-prefetch';
import welcomeMatImage from '../../../../../../public/assets/img/welcome-mat.svg';

const WELCOME_STEPS = [
  'Let’s get to know you.',
  'Pick the services you actually want to include.',
  'Choose the cover for you.',
];

const Welcome = () => {
  const router = useRouter();

  // prefetches first step to be closer to the old SPA experience
  usePrefetch(buildNavigationUrl(STEP_SLUG.ABOUT_YOU, PRODUCT_TYPE.PACKAGE));

  return (
    <>
      <Section className={styles.styledSection} variant="large">
        <H1 looksLike="h2">Choose your own hospital & extras</H1>
        <P className={styles.styledP}>
          Explore hospital and extras cover options based on what’s important to you and create a health insurance
          package in a matter of minutes.
        </P>
        <AxisSwitcher limit={2} threshold="61rem" space="1rem">
          <SpacerWrapper>
            <StepList isVertical steps={WELCOME_STEPS} />
          </SpacerWrapper>
          <div className={styles.imageWrapper}>
            <Image
              src={welcomeMatImage.src}
              width="100%"
              alt="Illustration welcoming users to explore hospital and extras insurance options and build a personalised health insurance package"
            />
          </div>
        </AxisSwitcher>
        <Button
          className={styles.styledButton}
          onClick={() => router.push(buildNavigationUrl(STEP_SLUG.ABOUT_YOU, PRODUCT_TYPE.PACKAGE))}
        >
          Let’s go
        </Button>
      </Section>
      <Section variant={['paddingTopSpacer3', 'paddingBottomSpacer10']}>
        <Wrapper>
          <AccordionSection
            accordionId="build-your-cover-welcome"
            items={data}
            title="Common questions"
            image={{
              alt: 'Billboard stating "Got questions? We’ve got the answers"',
              src: questionsHeroImage.src,
            }}
          />
        </Wrapper>
      </Section>
    </>
  );
};

export default Welcome;
